var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 14.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7891 22.5C16.7891 22.8818 16.9351 23.2075 17.2383 23.4995L25.998 32.0684C26.2339 32.3154 26.5483 32.439 26.9077 32.439C27.6377 32.439 28.2104 31.8774 28.2104 31.1362C28.2104 30.7769 28.0645 30.4512 27.8174 30.2041L19.9224 22.5L27.8174 14.7959C28.0645 14.5376 28.2104 14.2119 28.2104 13.8525C28.2104 13.1226 27.6377 12.561 26.9077 12.561C26.5483 12.561 26.2339 12.6846 25.998 12.9316L17.2383 21.5005C16.9351 21.7925 16.8003 22.1182 16.7891 22.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.c3254271ec1fb41c9afba6f107ee7800.svg";
export { ForwardRef as ReactComponent };